export default __webpack_public_path__ + "media/images/88-42ddc2dac28e14b8d0b843b9c8abaf29.jpg";